/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccidentSeverityDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: AccidentSeverityDefinitionDto.source;
    label?: string;
}

export namespace AccidentSeverityDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
